export const getUTCTime = () => {
    const now = new Date();
    const isoString = now.toISOString();
    return isoString;
}